import UploadIcon from "../../svg/upload-icon";

const DocuploadButton = ({
  onClick,
  title = "Upload Document",
}: {
  onClick: () => void;
  title?: string;
}) => {
  return (
    <div
      className="flex cursor-pointer flex-row items-center justify-center gap-2 rounded-md bg-lightGray p-2 text-tiny font-semibold text-tertiaryBlue-4"
      onClick={onClick}
    >
      <UploadIcon />
      {title}
    </div>
  );
};

export default DocuploadButton;
